import { useQueryClient } from "@tanstack/react-query";
import { publishListing } from "../../api";
import { Listing } from "../../types";
import { AxiosResponse } from "axios";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

export function usePublishListing() {
  const queryClient = useQueryClient();

  const mutationPublishListing = useDomainMutation<
    AxiosResponse<Listing>,
    { response?: { data?: { message?: string } } },
    string
  >({
    mutationFn: (uid: string) => publishListing(uid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["listings"] });
    },
  });

  return mutationPublishListing;
}
